import React, { useEffect, useState } from "react";
import CustomerNavbar from "../../../components/CustomerNavar/CustomerNavbar";
import customerimg from "../../../images/customerpannel.png";
import Wrapper from "../../../components/UI/Wrapper";
import search from "../../../images/SearchIcon.png";
import axios from "axios";
import CryptoJS from 'crypto-js';
import './OrderData.css'; 

const OrderData = () => {
  const [orderSummary, setOrderSummary] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("accessToken")); 
    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerOrderSummary`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            
          },
        })
        .then((response) => {          
          if (response) {
            setOrderSummary(response.data.data);
            
          }
          else {
            console.error("Invalid token or expired session:", response.data.message);
            // Handle invalid token scenario
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
    return encodeURIComponent(ciphertext);
  }

  function getDetails(Relocation_ID) {
    const key = 'dbbworldwidepvtltd';
  
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/ViewOrderDetails-Customer?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, '_blank'); 
  }

  return (
    <>
      <CustomerNavbar />

      <div className="background">
        <div className="image-container">
          <img
            src={customerimg}
            alt="img"
            className="customer-image"
          />
        </div>
      </div>

      <div>
        <div className="sscroll">
          <Wrapper className="orderlist">
            <div className="content-container-orderlist">
              <div className="container-fluid">
                <div>
                  <div className="order-summary-header">
                    <h3 className="order-summary-title">
                      Order Summary
                    </h3>
                  </div>

                  <div className="table-div">
                  <table className="orderlist">
                    <thead>               
                      <tr  >
                        <th>Sr No</th>
                        <th>Customer ID</th>
                        <th>Service Type</th>
                        <th>No. of Pets</th>
                        <th>Pet Name & Breed</th>
                        <th>Origin</th>
                        <th>Destination</th>
                        <th>Relocation date</th>
                        <th>Details</th>
                      </tr>
                      </thead>
 <tbody>
                   
                
                      {orderSummary.length > 0 ? (
                        orderSummary.map((item, index) => (
                          <tr  key={index}>
                            <td>{index + 1}</td>
                            <td>{item.Relocation_ID}</td>
                            <td>{item.service_type}</td>
                            <td>{item.Number_Of_Pets}</td>
                            <td>{`${item.pet_Name} {${item.pet_breed}}`}</td>
                            <td>{`${item.origin_state}, ${item.origin_country}`}</td>
                            <td>{`${item.destination_state}, ${item.destination_country}`}</td>
                            <td>{item.relocation_date}</td>
                            <td>
                              <button
                                className="details-button"
                                onClick={() => {
                                  getDetails(item.Relocation_ID)
                                }}
                              >
                                <img src={search} alt="" />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9">No orders found</td>
                        </tr>
                      )}
                 </tbody>
                  </table>
                  </div>
                  <nav aria-label="Page navigation" className="pagination-container">
                    <ul className="pagination">
                      <li className="page-item">
                        <a
                          className="page-link"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            // handlePageChange(currentPage - 1);
                          }}
                          // disabled={currentPage === 1}
                        >
                          Previous
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          className="page-link"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            // handlePageChange(currentPage - 1);
                          }}
                          // disabled={currentPage === 1}
                        >
                          {/* {currentPage - 1} */}
                        </a>
                      </li>
                      <li className="page-item active">
                        {/* <a className="page-link">{currentPage}</a> */}
                      </li>
                      <li className="page-item">
                        <a
                          className="page-link"
                          style={{ cursor: "pointer" }}
                          // onClick={() => {
                          //   handlePageChange(currentPage + 1);
                          // }}
                          // disabled={endIndex >= userDetailResponse?.length}
                        >
                          {/* {currentPage + 1} */}
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          className="page-link"
                          style={{ cursor: "pointer" }}
                          // onClick={() => {
                          //   handlePageChange(currentPage + 1);
                          // }}
                          // disabled={endIndex >= userDetailResponse?.length}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </Wrapper>
          <div className="thank-you-container">
            <span className="thank-you-text">Thank You!</span>
            <br />
            <span className="thank-you-text thank-you-text-mobile">For choosing our Service.</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderData;

